import createEmbedCode from 'shared/helpers/create-embed-code';

export default function createEmbedCodeFromLayout({ layout, ...rest }) {
  const dimensions = { width: layout.sizeValue, height: layout.sizeValue };

  if (layout.layoutName === 'Horizontal') {
    dimensions.width = '100%';
  }

  return createEmbedCode({ ...rest, ...dimensions });
}
